<template>
  <div class="main-content-container container-fluid px-4">
  	<div>
    <div class="d-flex justify-content-center py-4" v-if="isLoading">
      <loader/>
    </div>
  		<div class="page-header row no-gutters py-4" v-if="!isLoading">
  			<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
  				<span class="text-uppercase page-subtitle">Usuarios</span>
  				<h3 class="page-title">Visión general</h3>
  			</div>
  		</div>
     <div class="row">
        <div class="col-lg-4" v-for="(item, index) of users" v-if="item.id !== $store.state.auth.user.id && item.is_active">
          <router-link :to="'/usuario/'+item.username" class="no-hover">
            <div class="card card-small mb-4 pt-3">
              <div class="card-header border-bottom text-center">
                <div class="mb-3 mx-auto">
                  <img class="rounded-circle" :src="item.photo" alt="User Avatar" width="110">
                </div>
                <h4 class="mb-0">{{ item.name }}  {{ item.lastname }}</h4>
                <span class="text-muted d-block mb-2">{{ item.profile }}</span>
              </div>
              <div class="card-footer border-top text-primary">
                <span class="badge badge-secondary mr-2">
                  <i class="fas fa-trash" @click.prevent="deleteOption(item.id, index)"/>
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
  	</div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        isLoading: true,
        users: null
      }
    },
    methods: {
      async getUsers() {
        const url = `${process.env.VUE_APP_ROOT_API}/user`;
        const response = await fetch(url);
        if(response.status == 200) {
          this.isLoading = false
          this.users = await response.json();
        }
      },

      deleteOption(id, index) {
        const message = '¿Estás seguro de querer eliminar a este usuario?';
        const options = {
          okText: 'Sí',
          cancelText: 'No'
        };
        let that = this;
        this.$dialog
          .confirm(message, options)
          .then(function(dialog) {
            that.deleteUser(id, index);
          });
      },

      async deleteUser(id, index) {
        const url = `${process.env.VUE_APP_ROOT_API}/user/disable/${id}}`;
        const settings = {
          method: 'POST'
        };
        const response = await fetch(url, settings);
        switch (response.status) {
          case 200:
            this.users.splice(index, 1);
            this.$store.dispatch('disable_user');
            break;
        }
      }
    },
    mounted() {
      this.getUsers();
    }
  }
</script>